/* First-touch form attribution, Meta Lead on confirmed contact/trial forms and booking clicks, and Google booking events. Shopify's privacy API is the authority.
   No marketing storage or Meta SDK before marketing AND sale/sharing permission. */
(function () {
  'use strict';
  if (window.__owTrackingInstalled) return;
  window.__owTrackingInstalled = true;
  var config = document.querySelector('script[data-ow-tracking]');
  if (!config) return;
  var pixelId = config.getAttribute('data-pixel-id') || '';
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'landing_page', 'offer'];
  var ATTR_KEY = 'ow-first-touch-v1';
  var PENDING_KEY = 'ow-meta-pending-v1';
  var RETENTION = 90 * 24 * 60 * 60 * 1000;
  var firstPage = window.location.origin + window.location.pathname;
  var firstParams = new URLSearchParams(window.location.search);
  var attribution = null;
  var pending = {};
  var active = false;
  var cleared = false;
  var initialized = false;
  var processed = new WeakSet();
  var candidates = new WeakMap();

  function privacyReady() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!privacy && typeof privacy.marketingAllowed === 'function' && typeof privacy.saleOfDataAllowed === 'function';
  }
  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (error) { return false; }
  }
  function read(store, key) {
    try { return JSON.parse(window[store].getItem(key)); } catch (error) { return null; }
  }
  function write(store, key, value) {
    try { window[store].setItem(key, JSON.stringify(value)); } catch (error) {}
  }
  function remove(store, key) {
    try { window[store].removeItem(key); } catch (error) {}
  }
  function clean(value) { return typeof value === 'string' ? value.slice(0, 500) : ''; }
  // ?offer=a or ?offer=b picks the first offer on the launch band; keep a short slug only.
  function offerSlug(value) { return typeof value === 'string' && /^[a-z0-9_-]{1,32}$/i.test(value) ? value.toLowerCase() : ''; }
  function capture() {
    if (attribution) return;
    var stored = read('localStorage', ATTR_KEY);
    if (stored && stored.created_at > Date.now() - RETENTION && stored.created_at <= Date.now() && stored.values) {
      attribution = {};
      KEYS.forEach(function (key) { attribution[key] = clean(stored.values[key]); });
    } else {
      attribution = {};
      KEYS.forEach(function (key) { attribution[key] = key === 'landing_page' ? firstPage : key === 'offer' ? offerSlug(firstParams.get(key)) : clean(firstParams.get(key)); });
      write('localStorage', ATTR_KEY, { created_at: Date.now(), values: attribution });
    }
  }
  function forms() {
    return Array.prototype.filter.call(document.forms, function (form) {
      var type = form.querySelector('input[name="form_type"]');
      return form.hasAttribute('data-ow-contact') || form.hasAttribute('data-ow-lead-name') ||
        !!(type && (type.value === 'contact' || type.value === 'customer'));
    });
  }
  function setEventId(form, id) {
    var input = form.querySelector('input[name="contact[event_id]"]');
    if (!input && id && allowed()) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = 'contact[event_id]';
      form.appendChild(input);
    }
    if (input) input.value = allowed() ? id : '';
  }
  function fill(form) {
    if (!allowed()) setEventId(form, '');
    KEYS.forEach(function (key) {
      var name = 'contact[' + key + ']';
      var input = form.querySelector('input[name="' + name + '"]');
      if (!input && attribution && allowed()) {
        input = document.createElement('input');
        input.type = 'hidden'; input.name = name;
        form.appendChild(input);
      }
      var value = attribution && allowed() ? attribution[key] : '';
      if (input && input.value !== value) input.value = value;
    });
  }
  function ensurePixel() {
    if (!pixelId || initialized || !allowed()) return;
    if (typeof window.fbq !== 'function') {
      var fbq = window.fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
    }
    window.fbq('consent', 'grant');
    window.fbq('set', 'autoConfig', false, pixelId);
    var state = typeof window.fbq.getState === 'function' ? window.fbq.getState() : null;
    var exists = state && state.pixels && state.pixels.some(function (pixel) { return pixel.id === pixelId; });
    if (!exists) window.fbq('init', pixelId);
    if (!document.querySelector('script[src*="connect.facebook.net/"]')) {
      var script = document.createElement('script');
      script.async = true; script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    initialized = true;
  }
  function track(event, name, eventId) {
    if (!pixelId || !allowed() || !eventId || (event !== 'Lead' && event !== 'Contact')) return;
    ensurePixel();
    var params = name ? { content_name: name } : {};
    window.fbq('trackSingle', pixelId, event, params, { eventID: eventId });
  }
  function identity(form) {
    var magnet = form.getAttribute('data-ow-lead-name');
    var marker = form.querySelector('[data-ow-lead-name]');
    if (!magnet && marker) magnet = marker.getAttribute('data-ow-lead-name');
    if (magnet) return { event: 'Lead', name: clean(magnet) };
    // Newsletter forms can also carry tags like "lead, start-free". Never infer from those tags.
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== 'contact') return null;
    if (form.id === 'start-form') return { event: 'Lead', name: 'trial' };
    return { event: 'Lead', name: 'contact' };
  }
  function pendingKey(form) { return window.location.pathname + ':' + form.id; }
  function reconcilePending() {
    // Shopify may render an intermediate challenge using the theme, including locale routes.
    // Preserve correlation only; Shopify still owns the challenge and acceptance.
    if (config.getAttribute('data-page-type') === 'captcha') {
      Object.keys(pending).forEach(function (key) {
        if (!pending[key] || pending[key].at < Date.now() - 30 * 60 * 1000) delete pending[key];
      });
      write('sessionStorage', PENDING_KEY, pending);
      return;
    }
    // A native return is useful only when this document confirms that exact form.
    // Errors, abandoned GETs and another page must not leave an old lead armed.
    var confirmed = {};
    forms().forEach(function (form) {
      var key = pendingKey(form), submission = pending[key];
      if (submission && submission.at >= Date.now() - 30 * 60 * 1000 &&
          form.querySelector('[data-ow-sent], [data-ow-tracking-success]') && !form.querySelector('[data-ow-error]')) {
        confirmed[key] = submission;
      }
    });
    pending = confirmed;
    write('sessionStorage', PENDING_KEY, pending);
  }
  function successes() {
    forms().forEach(function (form) {
      if (processed.has(form) || !form.querySelector('[data-ow-sent], [data-ow-tracking-success]')) return;
      // A success marker belongs to this response, even when no pending ID matches.
      // Never let a later submit on a reloaded success page reuse that old marker.
      processed.add(form);
      var key = pendingKey(form), submission = pending[key];
      if (!submission || submission.at < Date.now() - 30 * 60 * 1000 || !identity(form)) return;
      setEventId(form, submission.id);
      delete pending[key];
      write('sessionStorage', PENDING_KEY, pending);
      track(submission.event, submission.name, submission.id);
    });
  }
  function sync() {
    if (!allowed()) {
      if (privacyReady() && (active || !cleared)) {
        if (active && initialized && typeof window.fbq === 'function') window.fbq('consent', 'revoke');
        remove('localStorage', ATTR_KEY); remove('sessionStorage', PENDING_KEY);
        attribution = null; pending = {}; active = false; cleared = true;
      }
      forms().forEach(fill);
      return;
    }
    if (!active) {
      active = true; cleared = false; capture();
      var storedPending = read('sessionStorage', PENDING_KEY);
      pending = storedPending && typeof storedPending === 'object' && !Array.isArray(storedPending) ? storedPending : {};
      reconcilePending();
      if (initialized && typeof window.fbq === 'function') window.fbq('consent', 'grant');
    }
    forms().forEach(fill);
    successes();
  }
  // Capture on window before legacy document handlers can stop submit propagation.
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (forms().indexOf(form) < 0) return;
    sync(); fill(form);
    if (!allowed() || !pixelId || !form.id || !identity(form) || !form.checkValidity()) return;
    if (!event.isTrusted) return;
    setEventId(form, '');
    candidates.set(form, event);
    // Native formdata follows the accepted submit default action in this task.
    setTimeout(function () { if (candidates.get(form) === event) candidates.delete(form); }, 0);
  }, true);
  document.addEventListener('formdata', function (event) {
    if (forms().indexOf(event.target) < 0) return;
    sync();
    var form = event.target, submission = candidates.get(form);
    // A FormData constructor inside a submit handler runs before eventPhase is NONE.
    // Requiring completed, uncanceled dispatch avoids native-listener microtask races.
    if (submission && submission.eventPhase === 0 && !submission.defaultPrevented && allowed() && pixelId) {
      candidates.delete(form);
      var lead = identity(form);
      if (lead) {
        pending[pendingKey(form)] = { event: lead.event, name: lead.name, at: Date.now(), id: 'ow-' + Date.now() + '-' + Math.random().toString(36).slice(2) };
        setEventId(form, pending[pendingKey(form)].id);
        write('sessionStorage', PENDING_KEY, pending);
      }
    }
    var eventId = form.querySelector('input[name="contact[event_id]"]');
    if (allowed() && eventId && eventId.value) event.formData.set('contact[event_id]', eventId.value);
    else event.formData.delete('contact[event_id]');
    KEYS.forEach(function (key) {
      var name = 'contact[' + key + ']';
      if (allowed() && attribution) event.formData.set(name, attribution[key]);
      else event.formData.delete(name);
    });
  });
  // Booking links (no form). A trusted click on a link to the booking calendar, or on any a[data-ow-contact-click], is one tracked click per link per page view.
  // Calendar links always report book_call_click and generate_lead (lead_type booking_click) through dataLayer and gtag (Google consent mode governs those, no personal data),
  // and, only with consent, one Meta trackSingle Lead with content_name book_call. Other a[data-ow-contact-click] links send the Meta Contact with their own name.
  var BOOKING_HOSTS = ['calendar.app.google', 'calendar.google.com'];
  var clicked = new WeakSet();
  var announced = new WeakSet();
  function isBooking(link) {
    try { return BOOKING_HOSTS.indexOf(new URL(link.getAttribute('href'), window.location.href).hostname) >= 0; } catch (error) { return false; }
  }
  function announceBooking(link) {
    if (announced.has(link)) return;
    announced.add(link);
    var url;
    try { url = new URL(link.getAttribute('href'), window.location.href); } catch (error) { return; }
    var detail = { link_url: url.origin + url.pathname, page_path: window.location.pathname };
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'book_call_click', link_url: detail.link_url, page_path: detail.page_path }); } catch (error) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'book_call_click', detail); } catch (error) {}
    try { window.dataLayer.push({ event: 'generate_lead', lead_type: 'booking_click', link_url: detail.link_url, page_path: detail.page_path }); } catch (error) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { lead_type: 'booking_click', link_url: detail.link_url, page_path: detail.page_path }); } catch (error) {}
  }
  function bookingClick(event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || !event.isTrusted || clicked.has(link)) return;
    var booking = isBooking(link);
    var marker = link.getAttribute('data-ow-contact-click');
    if (!booking && marker === null) return;
    if (booking) announceBooking(link);
    sync();
    if (!allowed() || !pixelId) return;
    clicked.add(link);
    track(booking ? 'Lead' : 'Contact', booking ? 'book_call' : clean(marker) || 'contact', 'ow-' + Date.now() + '-' + Math.random().toString(36).slice(2));
  }
  document.addEventListener('click', bookingClick, true);
  document.addEventListener('auxclick', function (event) { if (event.button === 1) bookingClick(event); }, true);
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  document.addEventListener('shopify:section:load', sync);
  new MutationObserver(function (records) {
    if (records.some(function (record) { return record.addedNodes.length > 0; })) sync();
  }).observe(document.body, { childList: true, subtree: true });

  var attempts = 0;
  function loadPrivacy() {
    sync();
    var shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) return;
    if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) { if (!error) sync(); });
      return;
    }
    if (++attempts < 40) setTimeout(loadPrivacy, 250);
  }
  loadPrivacy();
})();
